/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Schedule API - .Net 6
 * <b>Build:</b>Radianse.App.Schedule_main_2024.1.22.1
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
import type { RequestArgs } from "./base";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "./base";

/**
 * Class for PUT actualendtime of a schedule
 * @export
 * @interface IActualEndTimeDto
 */
export interface IActualEndTimeDto {
  /**
   * Actual end time
   * @type {string}
   * @memberof IActualEndTimeDto
   */
  actualTime: string;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IActualEndTimeDto
   */
  metaData?: { [key: string]: IMetaDataInfo };
}
/**
 * Class for PUT actualstarttime of a schedule
 * @export
 * @interface IActualStartTimeDto
 */
export interface IActualStartTimeDto {
  /**
   * Actual start time
   * @type {string}
   * @memberof IActualStartTimeDto
   */
  actualTime: string;
  /**
   * Requested duration as timespan. For example: \"00:05:00\" is 5 minutes.
   * @type {string}
   * @memberof IActualStartTimeDto
   */
  requestedDuration?: string | null;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IActualStartTimeDto
   */
  metaData?: { [key: string]: IMetaDataInfo };
}
/**
 * ClientTree type
 * @export
 * @enum {string}
 */

export const IClientTreeType = {
  Customer: "Customer",
  Tenant: "Tenant",
  Group: "Group",
} as const;

export type IClientTreeType =
  (typeof IClientTreeType)[keyof typeof IClientTreeType];

/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 *
 * @export
 * @interface IMetaDataInfo
 */
export interface IMetaDataInfo {
  /**
   * Dynamic data
   * @type {any}
   * @memberof IMetaDataInfo
   */
  data?: any;
}
/**
 * Operator type for query operations
 * @export
 * @enum {string}
 */

export const IQueryOperatorType = {
  Equals: "Equals",
  LessThan: "LessThan",
  LessThanOrEquals: "LessThanOrEquals",
  GreaterThan: "GreaterThan",
  GreaterThanOrEquals: "GreaterThanOrEquals",
  NotEquals: "NotEquals",
  NotNull: "NotNull",
  IsNull: "IsNull",
  IsDefined: "IsDefined",
  NotDefined: "NotDefined",
  IsNotNullAndIsDefined: "IsNotNullAndIsDefined",
  IsNullOrNotIsDefined: "IsNullOrNotIsDefined",
} as const;

export type IQueryOperatorType =
  (typeof IQueryOperatorType)[keyof typeof IQueryOperatorType];

/**
 * Rules and requirements. Used for scheduling equipment, facility, etc...
 * @export
 * @interface IRulesValidation
 */
export interface IRulesValidation {
  /**
   * The token of the validation of the rules associated with the schedule
   * @type {string}
   * @memberof IRulesValidation
   */
  rulesToken?: string;
  /**
   * The requirement of the rules validation that must be performed.
   * @type {string}
   * @memberof IRulesValidation
   */
  requirementTypeId?: string;
}
/**
 * Schedule
 * @export
 * @interface ISchedule
 */
export interface ISchedule {
  /**
   * Name
   * @type {string}
   * @memberof ISchedule
   */
  name: string;
  /**
   * Start time
   * @type {string}
   * @memberof ISchedule
   */
  startTime: string;
  /**
   * Location of schedule creation.
   * @type {string}
   * @memberof ISchedule
   */
  creationLocation: string;
  /**
   * Time zone id.
   * @type {string}
   * @memberof ISchedule
   */
  timeZoneId: string;
  /**
   * Unique ID
   * @type {string}
   * @memberof ISchedule
   */
  id?: string | null;
  /**
   * PartionKey
   * @type {string}
   * @memberof ISchedule
   */
  partitionKey?: string | null;
  /**
   * Category
   * @type {string}
   * @memberof ISchedule
   */
  category?: string;
  /**
   * SubCategory
   * @type {string}
   * @memberof ISchedule
   */
  subCategory?: string;
  /**
   * The requirements and token of validated rules requirements.
   * @type {Array<IRulesValidation>}
   * @memberof ISchedule
   */
  rulesValidations?: Array<IRulesValidation> | null;
  /**
   * Minutes since last category
   * @type {number}
   * @memberof ISchedule
   */
  minutesSinceLastCategory?: number | null;
  /**
   * End time
   * @type {string}
   * @memberof ISchedule
   */
  endTime?: string | null;
  /**
   * Create date
   * @type {string}
   * @memberof ISchedule
   */
  createDate?: string | null;
  /**
   * Last update
   * @type {string}
   * @memberof ISchedule
   */
  lastUpdate?: string | null;
  /**
   * Cancel date
   * @type {string}
   * @memberof ISchedule
   */
  cancelDate?: string | null;
  /**
   * CRON expression when a schedule is recurring
   * @type {string}
   * @memberof ISchedule
   */
  recurringCron?: string | null;
  /**
   * The CRON start time
   * @type {string}
   * @memberof ISchedule
   */
  recurringStart?: string | null;
  /**
   * The CRON end time
   * @type {string}
   * @memberof ISchedule
   */
  recurringEnd?: string | null;
  /**
   * The time the schedule was actually started
   * @type {string}
   * @memberof ISchedule
   */
  actualStartTime?: string | null;
  /**
   * The time the schedule actually ended
   * @type {string}
   * @memberof ISchedule
   */
  actualEndTime?: string | null;
  /**
   * Requested duration of the schedule
   * @type {string}
   * @memberof ISchedule
   */
  requestedDuration?: string | null;
  /**
   * Actual duration of the schedule
   * @type {string}
   * @memberof ISchedule
   */
  actualDuration?: string | null;
  /**
   * Resources needed for the scheduled time
   * @type {Array<IScheduleResourceInfo>}
   * @memberof ISchedule
   */
  resources?: Array<IScheduleResourceInfo> | null;
  /**
   * Note about the schedule.
   * @type {string}
   * @memberof ISchedule
   */
  note?: string | null;
  /**
   * Customer specific information for display purposes.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof ISchedule
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
  /**
   *
   * @type {IScheduleChangeOriginType}
   * @memberof ISchedule
   */
  scheduleChangeOrigin?: IScheduleChangeOriginType;
}
/**
 * Schedule changes done in legacy or new system
 * @export
 * @enum {string}
 */

export const IScheduleChangeOriginType = {
  Legacy: "Legacy",
  SkyView: "SkyView",
} as const;

export type IScheduleChangeOriginType =
  (typeof IScheduleChangeOriginType)[keyof typeof IScheduleChangeOriginType];

/**
 * Schedule
 * @export
 * @interface IScheduleDto
 */
export interface IScheduleDto {
  /**
   *
   * @type {IScheduleSubCategoryType}
   * @memberof IScheduleDto
   */
  subCategory: IScheduleSubCategoryType;
  /**
   * Name of the schedule
   * @type {string}
   * @memberof IScheduleDto
   */
  name: string;
  /**
   * Start time
   * @type {string}
   * @memberof IScheduleDto
   */
  startTime: string;
  /**
   * Where the schedule was created
   * @type {string}
   * @memberof IScheduleDto
   */
  creationLocation: string;
  /**
   * The time zone identifier, which corresponds to the System.TimeZoneInfo.Id property. If  null, UTC time zone will be used. https://docs.microsoft.com/en-us/dotnet/api/system.timezoneinfo.id?view=net-5.0
   * @type {string}
   * @memberof IScheduleDto
   */
  timeZoneId: string;
  /**
   * The requirements and token of validated rules requirements for the rules stage \"Schedule\"
   * @type {Array<IRulesValidation>}
   * @memberof IScheduleDto
   */
  rulesValidations?: Array<IRulesValidation> | null;
  /**
   * Minutes since last category
   * @type {number}
   * @memberof IScheduleDto
   */
  minutesSinceLastCategory?: number | null;
  /**
   * End time
   * @type {string}
   * @memberof IScheduleDto
   */
  endTime?: string | null;
  /**
   * Date schedule created
   * @type {string}
   * @memberof IScheduleDto
   */
  createDate?: string | null;
  /**
   * Last time schedule updated
   * @type {string}
   * @memberof IScheduleDto
   */
  lastUpdate?: string | null;
  /**
   * Time schedule was cancelled
   * @type {string}
   * @memberof IScheduleDto
   */
  cancelDate?: string | null;
  /**
   * CRON expression when a schedule is recurring
   * @type {string}
   * @memberof IScheduleDto
   */
  recurringCron?: string | null;
  /**
   * The CRON start time
   * @type {string}
   * @memberof IScheduleDto
   */
  recurringStart?: string | null;
  /**
   * The CRON end time
   * @type {string}
   * @memberof IScheduleDto
   */
  recurringEnd?: string | null;
  /**
   * Time the schedule actually started
   * @type {string}
   * @memberof IScheduleDto
   */
  actualStartTime?: string | null;
  /**
   * Time the schedule actually ended
   * @type {string}
   * @memberof IScheduleDto
   */
  actualEndTime?: string | null;
  /**
   * Schedule resources
   * @type {Array<IScheduleResourceInfo>}
   * @memberof IScheduleDto
   */
  resources?: Array<IScheduleResourceInfo> | null;
  /**
   * Note about the schedule.
   * @type {string}
   * @memberof IScheduleDto
   */
  note?: string | null;
  /**
   * Customer specific information for display purposes. Business logic should not be done.
   * @type {{ [key: string]: IMetaDataInfo; }}
   * @memberof IScheduleDto
   */
  metaData?: { [key: string]: IMetaDataInfo } | null;
}
/**
 *
 * @export
 * @interface IScheduleIRadianseResult
 */
export interface IScheduleIRadianseResult {
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {number}
   * @memberof IScheduleIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {ISchedule}
   * @memberof IScheduleIRadianseResult
   */
  data?: ISchedule;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IScheduleIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IScheduleIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IScheduleIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IScheduleIRadianseResultSuccess
 */
export interface IScheduleIRadianseResultSuccess {
  /**
   *
   * @type {ISchedule}
   * @memberof IScheduleIRadianseResultSuccess
   */
  data: ISchedule;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {number}
   * @memberof IScheduleIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IScheduleIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IScheduleIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IScheduleIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IScheduleListIRadianseResult
 */
export interface IScheduleListIRadianseResult {
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {number}
   * @memberof IScheduleListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<ISchedule>}
   * @memberof IScheduleListIRadianseResult
   */
  data?: Array<ISchedule> | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IScheduleListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IScheduleListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IScheduleListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IScheduleListIRadianseResultSuccess
 */
export interface IScheduleListIRadianseResultSuccess {
  /**
   *
   * @type {Array<ISchedule>}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  data: Array<ISchedule>;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {number}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IScheduleListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IScheduleResourceInfo
 */
export interface IScheduleResourceInfo {
  /**
   * id
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  id: string;
  /**
   * Partition key
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  partitionKey: string;
  /**
   * Category
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  category: string;
  /**
   * SubCategory
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  subCategory: string;
  /**
   * Name
   * @type {string}
   * @memberof IScheduleResourceInfo
   */
  name: string;
}
/**
 * Schedule subcategory allowed values
 * @export
 * @enum {string}
 */

export const IScheduleSubCategoryType = {
  ScheduleEvents: "ScheduleEvents",
  Maintenance: "Maintenance",
  ReportingSchedule: "ReportingSchedule",
} as const;

export type IScheduleSubCategoryType =
  (typeof IScheduleSubCategoryType)[keyof typeof IScheduleSubCategoryType];

/**
 *
 * @export
 * @interface IStringIRadianseResult
 */
export interface IStringIRadianseResult {
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  data?: string | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IStringIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IStringIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IStringIRadianseResultSuccess
 */
export interface IStringIRadianseResultSuccess {
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  data: string;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {number}
   * @memberof IStringIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IStringIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IStringIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IStringIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IStringIRadianseResultSuccess
   */
  continuationToken?: string | null;
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [groupId] If using bearer token and would like to see group roles, include groupId.
     * @param {string} [tenantId] If using bearer token and would like to see tenant roles, include tenantId.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [groupId] If using bearer token and would like to see group roles, include groupId.
     * @param {string} [tenantId] If using bearer token and would like to see tenant roles, include tenantId.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["RequestContextApi.userApiRequestContextGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [groupId] If using bearer token and would like to see group roles, include groupId.
     * @param {string} [tenantId] If using bearer token and would like to see tenant roles, include tenantId.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - interface
 * @export
 * @interface RequestContextApi
 */
export interface RequestContextApiInterface {
  /**
   *
   * @summary
   * @param {string} [groupId] If using bearer token and would like to see group roles, include groupId.
   * @param {string} [tenantId] If using bearer token and would like to see tenant roles, include tenantId.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApiInterface
   */
  userApiRequestContextGet(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IIRadianseRequestContext>;
}

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi
  extends BaseAPI
  implements RequestContextApiInterface
{
  /**
   *
   * @summary
   * @param {string} [groupId] If using bearer token and would like to see group roles, include groupId.
   * @param {string} [tenantId] If using bearer token and would like to see tenant roles, include tenantId.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ScheduleApi - axios parameter creator
 * @export
 */
export const ScheduleApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Set CancelDate to current utc time
     * @summary Cancel a schedule
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleCancelIdDelete: async (
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiScheduleCancelIdDelete", "id", id);
      const localVarPath = `/UserApi/Schedule/Cancel/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules csv
     * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
     * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
     * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
     * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
     * @param {string} [resourceId] Search for schedules which contain this resource id
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not. Defaults to false.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleCsvGet: async (
      subCategory?: IScheduleSubCategoryType,
      clientTreeType?: IClientTreeType,
      startTime?: string,
      endTime?: string,
      startTimeOperator?: IQueryOperatorType,
      endTimeOperator?: IQueryOperatorType,
      cancelDate?: boolean,
      elementTreeId?: string,
      resourceId?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      actualTimes?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Schedule/Csv`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (subCategory !== undefined) {
        for (const [key, value] of Object.entries(subCategory)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (clientTreeType !== undefined) {
        for (const [key, value] of Object.entries(clientTreeType)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (startTime !== undefined) {
        localVarQueryParameter["startTime"] =
          (startTime as any) instanceof Date
            ? (startTime as any).toISOString()
            : startTime;
      }

      if (endTime !== undefined) {
        localVarQueryParameter["endTime"] =
          (endTime as any) instanceof Date
            ? (endTime as any).toISOString()
            : endTime;
      }

      if (startTimeOperator !== undefined) {
        for (const [key, value] of Object.entries(startTimeOperator)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endTimeOperator !== undefined) {
        for (const [key, value] of Object.entries(endTimeOperator)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (cancelDate !== undefined) {
        localVarQueryParameter["cancelDate"] = cancelDate;
      }

      if (elementTreeId !== undefined) {
        localVarQueryParameter["elementTreeId"] = elementTreeId;
      }

      if (resourceId !== undefined) {
        localVarQueryParameter["resourceId"] = resourceId;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (actualTimes !== undefined) {
        localVarQueryParameter["actualTimes"] = actualTimes;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules
     * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
     * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
     * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
     * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
     * @param {string} [resourceId] Search for schedules which contain this resource id
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleGet: async (
      subCategory?: IScheduleSubCategoryType,
      clientTreeType?: IClientTreeType,
      startTime?: string,
      endTime?: string,
      startTimeOperator?: IQueryOperatorType,
      endTimeOperator?: IQueryOperatorType,
      cancelDate?: boolean,
      elementTreeId?: string,
      resourceId?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      actualTimes?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Schedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (subCategory !== undefined) {
        for (const [key, value] of Object.entries(subCategory)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (clientTreeType !== undefined) {
        for (const [key, value] of Object.entries(clientTreeType)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (startTime !== undefined) {
        localVarQueryParameter["startTime"] =
          (startTime as any) instanceof Date
            ? (startTime as any).toISOString()
            : startTime;
      }

      if (endTime !== undefined) {
        localVarQueryParameter["endTime"] =
          (endTime as any) instanceof Date
            ? (endTime as any).toISOString()
            : endTime;
      }

      if (startTimeOperator !== undefined) {
        for (const [key, value] of Object.entries(startTimeOperator)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (endTimeOperator !== undefined) {
        for (const [key, value] of Object.entries(endTimeOperator)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (cancelDate !== undefined) {
        localVarQueryParameter["cancelDate"] = cancelDate;
      }

      if (elementTreeId !== undefined) {
        localVarQueryParameter["elementTreeId"] = elementTreeId;
      }

      if (resourceId !== undefined) {
        localVarQueryParameter["resourceId"] = resourceId;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (actualTimes !== undefined) {
        localVarQueryParameter["actualTimes"] = actualTimes;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read
     * @summary Get schedule by id
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleIdGet: async (
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiScheduleIdGet", "id", id);
      const localVarPath = `/UserApi/Schedule/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_create
     * @summary Create or edit schedule
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IScheduleDto} [iScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleIdPut: async (
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iScheduleDto?: IScheduleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiScheduleIdPut", "id", id);
      const localVarPath = `/UserApi/Schedule/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iScheduleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules on a customer by element tree id and person id
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} startTime
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet:
      async (
        personId: string,
        elementTreeId: string,
        startTime: string,
        endTime: string,
        cancelDate?: boolean,
        apiVersion?: string,
        acceptLanguage?: string,
        options: RawAxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'personId' is not null or undefined
        assertParamExists(
          "userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet",
          "personId",
          personId
        );
        // verify required parameter 'elementTreeId' is not null or undefined
        assertParamExists(
          "userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet",
          "elementTreeId",
          elementTreeId
        );
        // verify required parameter 'startTime' is not null or undefined
        assertParamExists(
          "userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet",
          "startTime",
          startTime
        );
        // verify required parameter 'endTime' is not null or undefined
        assertParamExists(
          "userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet",
          "endTime",
          endTime
        );
        const localVarPath =
          `/UserApi/Schedule/Person/{personId}/ElementTree/{elementTreeId}/Range/{startTime}/{endTime}`
            .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
            .replace(
              `{${"elementTreeId"}}`,
              encodeURIComponent(String(elementTreeId))
            )
            .replace(`{${"startTime"}}`, encodeURIComponent(String(startTime)))
            .replace(`{${"endTime"}}`, encodeURIComponent(String(endTime)));
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (cancelDate !== undefined) {
          localVarQueryParameter["cancelDate"] = cancelDate;
        }

        if (apiVersion !== undefined) {
          localVarQueryParameter["api-version"] = apiVersion;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Permission: schedule_read
     * @summary Get schedules on a customer by events id and person id
     * @param {string} personId
     * @param {string} eventsId
     * @param {string} startTime UTC Time
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet: async (
      personId: string,
      eventsId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet",
        "personId",
        personId
      );
      // verify required parameter 'eventsId' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet",
        "eventsId",
        eventsId
      );
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet",
        "startTime",
        startTime
      );
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet",
        "endTime",
        endTime
      );
      const localVarPath =
        `/UserApi/Schedule/Person/{personId}/Events/{eventsId}/Range/{startTime}/{endTime}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(`{${"eventsId"}}`, encodeURIComponent(String(eventsId)))
          .replace(`{${"startTime"}}`, encodeURIComponent(String(startTime)))
          .replace(`{${"endTime"}}`, encodeURIComponent(String(endTime)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (cancelDate !== undefined) {
        localVarQueryParameter["cancelDate"] = cancelDate;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules by person id on a tenant
     * @param {string} personId
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {IClientTreeType} [clientTreeType] Get all across customer, group, or tenant. Defaults to tenant.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet: async (
      personId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet",
        "personId",
        personId
      );
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet",
        "startTime",
        startTime
      );
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists(
        "userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet",
        "endTime",
        endTime
      );
      const localVarPath =
        `/UserApi/Schedule/Person/{personId}/Range/{startTime}/{endTime}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(`{${"startTime"}}`, encodeURIComponent(String(startTime)))
          .replace(`{${"endTime"}}`, encodeURIComponent(String(endTime)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (cancelDate !== undefined) {
        localVarQueryParameter["cancelDate"] = cancelDate;
      }

      if (clientTreeType !== undefined) {
        for (const [key, value] of Object.entries(clientTreeType)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_create
     * @summary Create schedule
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IScheduleDto} [iScheduleDto] Schedule to create. Schedule.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePost: async (
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iScheduleDto?: IScheduleDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Schedule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iScheduleDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules within a time range. Grouped by start time and events.
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time
     * @param {string} [subCategory] Schedule subcategory
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleRangeGroupedStartTimeEndTimeGet: async (
      startTime: string,
      endTime: string,
      subCategory?: string,
      clientTreeType?: IClientTreeType,
      cancelDate?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists(
        "userApiScheduleRangeGroupedStartTimeEndTimeGet",
        "startTime",
        startTime
      );
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists(
        "userApiScheduleRangeGroupedStartTimeEndTimeGet",
        "endTime",
        endTime
      );
      const localVarPath =
        `/UserApi/Schedule/Range/Grouped/{startTime}/{endTime}`
          .replace(`{${"startTime"}}`, encodeURIComponent(String(startTime)))
          .replace(`{${"endTime"}}`, encodeURIComponent(String(endTime)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (subCategory !== undefined) {
        localVarQueryParameter["subCategory"] = subCategory;
      }

      if (clientTreeType !== undefined) {
        for (const [key, value] of Object.entries(clientTreeType)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (cancelDate !== undefined) {
        localVarQueryParameter["cancelDate"] = cancelDate;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_read                Searches for schedule with StartTime between startTime and endTime
     * @summary Get all schedules within a time range
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time
     * @param {string} [subCategory] Schedule subcategory
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleRangeStartTimeEndTimeGet: async (
      startTime: string,
      endTime: string,
      subCategory?: string,
      clientTreeType?: IClientTreeType,
      cancelDate?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'startTime' is not null or undefined
      assertParamExists(
        "userApiScheduleRangeStartTimeEndTimeGet",
        "startTime",
        startTime
      );
      // verify required parameter 'endTime' is not null or undefined
      assertParamExists(
        "userApiScheduleRangeStartTimeEndTimeGet",
        "endTime",
        endTime
      );
      const localVarPath = `/UserApi/Schedule/Range/{startTime}/{endTime}`
        .replace(`{${"startTime"}}`, encodeURIComponent(String(startTime)))
        .replace(`{${"endTime"}}`, encodeURIComponent(String(endTime)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (subCategory !== undefined) {
        localVarQueryParameter["subCategory"] = subCategory;
      }

      if (clientTreeType !== undefined) {
        for (const [key, value] of Object.entries(clientTreeType)) {
          localVarQueryParameter[key] = value;
        }
      }

      if (cancelDate !== undefined) {
        localVarQueryParameter["cancelDate"] = cancelDate;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_edit
     * @summary Update actualEndTime of an existing schedule
     * @param {string} scheduleId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IActualEndTimeDto} [iActualEndTimeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleScheduleScheduleIdActualEndTimePut: async (
      scheduleId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iActualEndTimeDto?: IActualEndTimeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiScheduleScheduleScheduleIdActualEndTimePut",
        "scheduleId",
        scheduleId
      );
      const localVarPath =
        `/UserApi/Schedule/Schedule/{scheduleId}/ActualEndTime`.replace(
          `{${"scheduleId"}}`,
          encodeURIComponent(String(scheduleId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iActualEndTimeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: schedule_edit                Radianse.App.Connectors calls this endpoint via schedule client
     * @summary Update ActualStartTime of an existing schedule
     * @param {string} scheduleId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IActualStartTimeDto} [iActualStartTimeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleScheduleScheduleIdActualStartTimePut: async (
      scheduleId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iActualStartTimeDto?: IActualStartTimeDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'scheduleId' is not null or undefined
      assertParamExists(
        "userApiScheduleScheduleScheduleIdActualStartTimePut",
        "scheduleId",
        scheduleId
      );
      const localVarPath =
        `/UserApi/Schedule/Schedule/{scheduleId}/ActualStartTime`.replace(
          `{${"scheduleId"}}`,
          encodeURIComponent(String(scheduleId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iActualStartTimeDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ScheduleApi - functional programming interface
 * @export
 */
export const ScheduleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ScheduleApiAxiosParamCreator(configuration);
  return {
    /**
     * Set CancelDate to current utc time
     * @summary Cancel a schedule
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleCancelIdDelete(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleCancelIdDelete(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ScheduleApi.userApiScheduleCancelIdDelete"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules csv
     * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
     * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
     * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
     * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
     * @param {string} [resourceId] Search for schedules which contain this resource id
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not. Defaults to false.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleCsvGet(
      subCategory?: IScheduleSubCategoryType,
      clientTreeType?: IClientTreeType,
      startTime?: string,
      endTime?: string,
      startTimeOperator?: IQueryOperatorType,
      endTimeOperator?: IQueryOperatorType,
      cancelDate?: boolean,
      elementTreeId?: string,
      resourceId?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      actualTimes?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IStringIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleCsvGet(
          subCategory,
          clientTreeType,
          startTime,
          endTime,
          startTimeOperator,
          endTimeOperator,
          cancelDate,
          elementTreeId,
          resourceId,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          actualTimes,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ScheduleApi.userApiScheduleCsvGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules
     * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
     * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
     * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
     * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
     * @param {string} [resourceId] Search for schedules which contain this resource id
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleGet(
      subCategory?: IScheduleSubCategoryType,
      clientTreeType?: IClientTreeType,
      startTime?: string,
      endTime?: string,
      startTimeOperator?: IQueryOperatorType,
      endTimeOperator?: IQueryOperatorType,
      cancelDate?: boolean,
      elementTreeId?: string,
      resourceId?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      actualTimes?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleGet(
          subCategory,
          clientTreeType,
          startTime,
          endTime,
          startTimeOperator,
          endTimeOperator,
          cancelDate,
          elementTreeId,
          resourceId,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          actualTimes,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ScheduleApi.userApiScheduleGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get schedule by id
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleIdGet(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleIdGet(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ScheduleApi.userApiScheduleIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_create
     * @summary Create or edit schedule
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IScheduleDto} [iScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleIdPut(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iScheduleDto?: IScheduleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleIdPut(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          iScheduleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ScheduleApi.userApiScheduleIdPut"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules on a customer by element tree id and person id
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} startTime
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
      personId: string,
      elementTreeId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
          personId,
          elementTreeId,
          startTime,
          endTime,
          cancelDate,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules on a customer by events id and person id
     * @param {string} personId
     * @param {string} eventsId
     * @param {string} startTime UTC Time
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
      personId: string,
      eventsId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
          personId,
          eventsId,
          startTime,
          endTime,
          cancelDate,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules by person id on a tenant
     * @param {string} personId
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {IClientTreeType} [clientTreeType] Get all across customer, group, or tenant. Defaults to tenant.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
      personId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
          personId,
          startTime,
          endTime,
          cancelDate,
          clientTreeType,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_create
     * @summary Create schedule
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IScheduleDto} [iScheduleDto] Schedule to create. Schedule.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiSchedulePost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iScheduleDto?: IScheduleDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiSchedulePost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iScheduleDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["ScheduleApi.userApiSchedulePost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules within a time range. Grouped by start time and events.
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time
     * @param {string} [subCategory] Schedule subcategory
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleRangeGroupedStartTimeEndTimeGet(
      startTime: string,
      endTime: string,
      subCategory?: string,
      clientTreeType?: IClientTreeType,
      cancelDate?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleRangeGroupedStartTimeEndTimeGet(
          startTime,
          endTime,
          subCategory,
          clientTreeType,
          cancelDate,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiScheduleRangeGroupedStartTimeEndTimeGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_read                Searches for schedule with StartTime between startTime and endTime
     * @summary Get all schedules within a time range
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time
     * @param {string} [subCategory] Schedule subcategory
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleRangeStartTimeEndTimeGet(
      startTime: string,
      endTime: string,
      subCategory?: string,
      clientTreeType?: IClientTreeType,
      cancelDate?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleRangeStartTimeEndTimeGet(
          startTime,
          endTime,
          subCategory,
          clientTreeType,
          cancelDate,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiScheduleRangeStartTimeEndTimeGet"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_edit
     * @summary Update actualEndTime of an existing schedule
     * @param {string} scheduleId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IActualEndTimeDto} [iActualEndTimeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleScheduleScheduleIdActualEndTimePut(
      scheduleId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iActualEndTimeDto?: IActualEndTimeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleScheduleScheduleIdActualEndTimePut(
          scheduleId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iActualEndTimeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiScheduleScheduleScheduleIdActualEndTimePut"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Permission: schedule_edit                Radianse.App.Connectors calls this endpoint via schedule client
     * @summary Update ActualStartTime of an existing schedule
     * @param {string} scheduleId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IActualStartTimeDto} [iActualStartTimeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiScheduleScheduleScheduleIdActualStartTimePut(
      scheduleId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iActualStartTimeDto?: IActualStartTimeDto,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IScheduleIRadianseResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiScheduleScheduleScheduleIdActualStartTimePut(
          scheduleId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iActualStartTimeDto,
          options
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "ScheduleApi.userApiScheduleScheduleScheduleIdActualStartTimePut"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ScheduleApi - factory interface
 * @export
 */
export const ScheduleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ScheduleApiFp(configuration);
  return {
    /**
     * Set CancelDate to current utc time
     * @summary Cancel a schedule
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleCancelIdDelete(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IStringIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleCancelIdDelete(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules csv
     * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
     * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
     * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
     * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
     * @param {string} [resourceId] Search for schedules which contain this resource id
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not. Defaults to false.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleCsvGet(
      subCategory?: IScheduleSubCategoryType,
      clientTreeType?: IClientTreeType,
      startTime?: string,
      endTime?: string,
      startTimeOperator?: IQueryOperatorType,
      endTimeOperator?: IQueryOperatorType,
      cancelDate?: boolean,
      elementTreeId?: string,
      resourceId?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      actualTimes?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IStringIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleCsvGet(
          subCategory,
          clientTreeType,
          startTime,
          endTime,
          startTimeOperator,
          endTimeOperator,
          cancelDate,
          elementTreeId,
          resourceId,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          actualTimes,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules
     * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
     * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
     * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
     * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
     * @param {string} [resourceId] Search for schedules which contain this resource id
     * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleGet(
      subCategory?: IScheduleSubCategoryType,
      clientTreeType?: IClientTreeType,
      startTime?: string,
      endTime?: string,
      startTimeOperator?: IQueryOperatorType,
      endTimeOperator?: IQueryOperatorType,
      cancelDate?: boolean,
      elementTreeId?: string,
      resourceId?: string,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      actualTimes?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleListIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleGet(
          subCategory,
          clientTreeType,
          startTime,
          endTime,
          startTimeOperator,
          endTimeOperator,
          cancelDate,
          elementTreeId,
          resourceId,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          actualTimes,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get schedule by id
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleIdGet(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleIdGet(id, tenantId, apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_create
     * @summary Create or edit schedule
     * @param {string} id
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IScheduleDto} [iScheduleDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleIdPut(
      id: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iScheduleDto?: IScheduleDto,
      options?: any
    ): AxiosPromise<IScheduleIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleIdPut(
          id,
          tenantId,
          apiVersion,
          acceptLanguage,
          iScheduleDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules on a customer by element tree id and person id
     * @param {string} personId
     * @param {string} elementTreeId
     * @param {string} startTime
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
      personId: string,
      elementTreeId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleListIRadianseResultSuccess> {
      return localVarFp
        .userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
          personId,
          elementTreeId,
          startTime,
          endTime,
          cancelDate,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules on a customer by events id and person id
     * @param {string} personId
     * @param {string} eventsId
     * @param {string} startTime UTC Time
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
      personId: string,
      eventsId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleListIRadianseResultSuccess> {
      return localVarFp
        .userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
          personId,
          eventsId,
          startTime,
          endTime,
          cancelDate,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get schedules by person id on a tenant
     * @param {string} personId
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {IClientTreeType} [clientTreeType] Get all across customer, group, or tenant. Defaults to tenant.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
      personId: string,
      startTime: string,
      endTime: string,
      cancelDate?: boolean,
      clientTreeType?: IClientTreeType,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleListIRadianseResultSuccess> {
      return localVarFp
        .userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
          personId,
          startTime,
          endTime,
          cancelDate,
          clientTreeType,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_create
     * @summary Create schedule
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IScheduleDto} [iScheduleDto] Schedule to create. Schedule.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiSchedulePost(
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iScheduleDto?: IScheduleDto,
      options?: any
    ): AxiosPromise<IScheduleIRadianseResultSuccess> {
      return localVarFp
        .userApiSchedulePost(
          tenantId,
          apiVersion,
          acceptLanguage,
          iScheduleDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read
     * @summary Get all schedules within a time range. Grouped by start time and events.
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time
     * @param {string} [subCategory] Schedule subcategory
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleRangeGroupedStartTimeEndTimeGet(
      startTime: string,
      endTime: string,
      subCategory?: string,
      clientTreeType?: IClientTreeType,
      cancelDate?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleListIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleRangeGroupedStartTimeEndTimeGet(
          startTime,
          endTime,
          subCategory,
          clientTreeType,
          cancelDate,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_read                Searches for schedule with StartTime between startTime and endTime
     * @summary Get all schedules within a time range
     * @param {string} startTime UTC time
     * @param {string} endTime UTC time
     * @param {string} [subCategory] Schedule subcategory
     * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
     * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [groupId]
     * @param {string} [tenantId]
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleRangeStartTimeEndTimeGet(
      startTime: string,
      endTime: string,
      subCategory?: string,
      clientTreeType?: IClientTreeType,
      cancelDate?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IScheduleListIRadianseResultSuccess> {
      return localVarFp
        .userApiScheduleRangeStartTimeEndTimeGet(
          startTime,
          endTime,
          subCategory,
          clientTreeType,
          cancelDate,
          maxItemCount,
          continuationToken,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_edit
     * @summary Update actualEndTime of an existing schedule
     * @param {string} scheduleId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IActualEndTimeDto} [iActualEndTimeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleScheduleScheduleIdActualEndTimePut(
      scheduleId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iActualEndTimeDto?: IActualEndTimeDto,
      options?: any
    ): AxiosPromise<IScheduleIRadianseResult> {
      return localVarFp
        .userApiScheduleScheduleScheduleIdActualEndTimePut(
          scheduleId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iActualEndTimeDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: schedule_edit                Radianse.App.Connectors calls this endpoint via schedule client
     * @summary Update ActualStartTime of an existing schedule
     * @param {string} scheduleId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IActualStartTimeDto} [iActualStartTimeDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiScheduleScheduleScheduleIdActualStartTimePut(
      scheduleId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iActualStartTimeDto?: IActualStartTimeDto,
      options?: any
    ): AxiosPromise<IScheduleIRadianseResult> {
      return localVarFp
        .userApiScheduleScheduleScheduleIdActualStartTimePut(
          scheduleId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          iActualStartTimeDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ScheduleApi - interface
 * @export
 * @interface ScheduleApi
 */
export interface ScheduleApiInterface {
  /**
   * Set CancelDate to current utc time
   * @summary Cancel a schedule
   * @param {string} id
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleCancelIdDelete(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IStringIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get all schedules csv
   * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
   * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
   * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
   * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
   * @param {string} [resourceId] Search for schedules which contain this resource id
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not. Defaults to false.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleCsvGet(
    subCategory?: IScheduleSubCategoryType,
    clientTreeType?: IClientTreeType,
    startTime?: string,
    endTime?: string,
    startTimeOperator?: IQueryOperatorType,
    endTimeOperator?: IQueryOperatorType,
    cancelDate?: boolean,
    elementTreeId?: string,
    resourceId?: string,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    actualTimes?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IStringIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get all schedules
   * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
   * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
   * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
   * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
   * @param {string} [resourceId] Search for schedules which contain this resource id
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleGet(
    subCategory?: IScheduleSubCategoryType,
    clientTreeType?: IClientTreeType,
    startTime?: string,
    endTime?: string,
    startTimeOperator?: IQueryOperatorType,
    endTimeOperator?: IQueryOperatorType,
    cancelDate?: boolean,
    elementTreeId?: string,
    resourceId?: string,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    actualTimes?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleListIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get schedule by id
   * @param {string} id
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleIdGet(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleIRadianseResultSuccess>;

  /**
   * Permission: schedule_create
   * @summary Create or edit schedule
   * @param {string} id
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IScheduleDto} [iScheduleDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleIdPut(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iScheduleDto?: IScheduleDto,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get schedules on a customer by element tree id and person id
   * @param {string} personId
   * @param {string} elementTreeId
   * @param {string} startTime
   * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
    personId: string,
    elementTreeId: string,
    startTime: string,
    endTime: string,
    cancelDate?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleListIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get schedules on a customer by events id and person id
   * @param {string} personId
   * @param {string} eventsId
   * @param {string} startTime UTC Time
   * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
    personId: string,
    eventsId: string,
    startTime: string,
    endTime: string,
    cancelDate?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleListIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get schedules by person id on a tenant
   * @param {string} personId
   * @param {string} startTime UTC time
   * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {IClientTreeType} [clientTreeType] Get all across customer, group, or tenant. Defaults to tenant.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
    personId: string,
    startTime: string,
    endTime: string,
    cancelDate?: boolean,
    clientTreeType?: IClientTreeType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleListIRadianseResultSuccess>;

  /**
   * Permission: schedule_create
   * @summary Create schedule
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IScheduleDto} [iScheduleDto] Schedule to create. Schedule.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiSchedulePost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iScheduleDto?: IScheduleDto,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleIRadianseResultSuccess>;

  /**
   * Permission: schedule_read
   * @summary Get all schedules within a time range. Grouped by start time and events.
   * @param {string} startTime UTC time
   * @param {string} endTime UTC time
   * @param {string} [subCategory] Schedule subcategory
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleRangeGroupedStartTimeEndTimeGet(
    startTime: string,
    endTime: string,
    subCategory?: string,
    clientTreeType?: IClientTreeType,
    cancelDate?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleListIRadianseResultSuccess>;

  /**
   * Permission: schedule_read                Searches for schedule with StartTime between startTime and endTime
   * @summary Get all schedules within a time range
   * @param {string} startTime UTC time
   * @param {string} endTime UTC time
   * @param {string} [subCategory] Schedule subcategory
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleRangeStartTimeEndTimeGet(
    startTime: string,
    endTime: string,
    subCategory?: string,
    clientTreeType?: IClientTreeType,
    cancelDate?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleListIRadianseResultSuccess>;

  /**
   * Permission: schedule_edit
   * @summary Update actualEndTime of an existing schedule
   * @param {string} scheduleId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IActualEndTimeDto} [iActualEndTimeDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleScheduleScheduleIdActualEndTimePut(
    scheduleId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iActualEndTimeDto?: IActualEndTimeDto,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleIRadianseResult>;

  /**
   * Permission: schedule_edit                Radianse.App.Connectors calls this endpoint via schedule client
   * @summary Update ActualStartTime of an existing schedule
   * @param {string} scheduleId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IActualStartTimeDto} [iActualStartTimeDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApiInterface
   */
  userApiScheduleScheduleScheduleIdActualStartTimePut(
    scheduleId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iActualStartTimeDto?: IActualStartTimeDto,
    options?: RawAxiosRequestConfig
  ): AxiosPromise<IScheduleIRadianseResult>;
}

/**
 * ScheduleApi - object-oriented interface
 * @export
 * @class ScheduleApi
 * @extends {BaseAPI}
 */
export class ScheduleApi extends BaseAPI implements ScheduleApiInterface {
  /**
   * Set CancelDate to current utc time
   * @summary Cancel a schedule
   * @param {string} id
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleCancelIdDelete(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleCancelIdDelete(
        id,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get all schedules csv
   * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
   * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
   * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
   * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
   * @param {string} [resourceId] Search for schedules which contain this resource id
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not. Defaults to false.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleCsvGet(
    subCategory?: IScheduleSubCategoryType,
    clientTreeType?: IClientTreeType,
    startTime?: string,
    endTime?: string,
    startTimeOperator?: IQueryOperatorType,
    endTimeOperator?: IQueryOperatorType,
    cancelDate?: boolean,
    elementTreeId?: string,
    resourceId?: string,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    actualTimes?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleCsvGet(
        subCategory,
        clientTreeType,
        startTime,
        endTime,
        startTimeOperator,
        endTimeOperator,
        cancelDate,
        elementTreeId,
        resourceId,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        actualTimes,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get all schedules
   * @param {IScheduleSubCategoryType} [subCategory] Schedule subcategory. Defaults to ScheduleEvents.
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {string} [startTime] Search for schedules &gt;&#x3D; to start time
   * @param {string} [endTime] Search for schedules &lt;&#x3D; to end time
   * @param {IQueryOperatorType} [startTimeOperator] Operator to apply to startTime query. Defaults to &gt;&#x3D;.
   * @param {IQueryOperatorType} [endTimeOperator] Operator to apply to endTime query. Defaults to &lt;&#x3D;.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [elementTreeId] Usage of this parameter causes a GET to be issued for every resource in the schedule to determine the elementTreeId value. Use only if necessary.
   * @param {string} [resourceId] Search for schedules which contain this resource id
   * @param {number} [maxItemCount] The maximum number of items to be retrieved. Defaults to 100.
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {boolean} [actualTimes] True if the startTime and endTime params refer to ActualStartTime and ActualEndTime. False if they do not.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleGet(
    subCategory?: IScheduleSubCategoryType,
    clientTreeType?: IClientTreeType,
    startTime?: string,
    endTime?: string,
    startTimeOperator?: IQueryOperatorType,
    endTimeOperator?: IQueryOperatorType,
    cancelDate?: boolean,
    elementTreeId?: string,
    resourceId?: string,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    actualTimes?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleGet(
        subCategory,
        clientTreeType,
        startTime,
        endTime,
        startTimeOperator,
        endTimeOperator,
        cancelDate,
        elementTreeId,
        resourceId,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        actualTimes,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get schedule by id
   * @param {string} id
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleIdGet(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleIdGet(id, tenantId, apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_create
   * @summary Create or edit schedule
   * @param {string} id
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IScheduleDto} [iScheduleDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleIdPut(
    id: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iScheduleDto?: IScheduleDto,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleIdPut(
        id,
        tenantId,
        apiVersion,
        acceptLanguage,
        iScheduleDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get schedules on a customer by element tree id and person id
   * @param {string} personId
   * @param {string} elementTreeId
   * @param {string} startTime
   * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
    personId: string,
    elementTreeId: string,
    startTime: string,
    endTime: string,
    cancelDate?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiSchedulePersonPersonIdElementTreeElementTreeIdRangeStartTimeEndTimeGet(
        personId,
        elementTreeId,
        startTime,
        endTime,
        cancelDate,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get schedules on a customer by events id and person id
   * @param {string} personId
   * @param {string} eventsId
   * @param {string} startTime UTC Time
   * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
    personId: string,
    eventsId: string,
    startTime: string,
    endTime: string,
    cancelDate?: boolean,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiSchedulePersonPersonIdEventsEventsIdRangeStartTimeEndTimeGet(
        personId,
        eventsId,
        startTime,
        endTime,
        cancelDate,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get schedules by person id on a tenant
   * @param {string} personId
   * @param {string} startTime UTC time
   * @param {string} endTime UTC time. Add a second if schedule.StartTime &#x3D; endTime must be included.
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {IClientTreeType} [clientTreeType] Get all across customer, group, or tenant. Defaults to tenant.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
    personId: string,
    startTime: string,
    endTime: string,
    cancelDate?: boolean,
    clientTreeType?: IClientTreeType,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiSchedulePersonPersonIdRangeStartTimeEndTimeGet(
        personId,
        startTime,
        endTime,
        cancelDate,
        clientTreeType,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_create
   * @summary Create schedule
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IScheduleDto} [iScheduleDto] Schedule to create. Schedule.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiSchedulePost(
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iScheduleDto?: IScheduleDto,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiSchedulePost(
        tenantId,
        apiVersion,
        acceptLanguage,
        iScheduleDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read
   * @summary Get all schedules within a time range. Grouped by start time and events.
   * @param {string} startTime UTC time
   * @param {string} endTime UTC time
   * @param {string} [subCategory] Schedule subcategory
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleRangeGroupedStartTimeEndTimeGet(
    startTime: string,
    endTime: string,
    subCategory?: string,
    clientTreeType?: IClientTreeType,
    cancelDate?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleRangeGroupedStartTimeEndTimeGet(
        startTime,
        endTime,
        subCategory,
        clientTreeType,
        cancelDate,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_read                Searches for schedule with StartTime between startTime and endTime
   * @summary Get all schedules within a time range
   * @param {string} startTime UTC time
   * @param {string} endTime UTC time
   * @param {string} [subCategory] Schedule subcategory
   * @param {IClientTreeType} [clientTreeType] If not included, return all tenant schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Customer\&quot;, return all customer schedules. &lt;para&gt;  If included and value is \&quot;Group\&quot;, return all group schedules. &lt;br&gt;&lt;/para&gt;  If included and value is \&quot;Tenant\&quot;, return all tenant schedules. &lt;para&gt;
   * @param {boolean} [cancelDate] True: Get cancelled schedules. Returns schedules which have non-null cancelDate                False: Get active schedules. Return schedules which have null cancelDate                Null: Get all
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [groupId]
   * @param {string} [tenantId]
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleRangeStartTimeEndTimeGet(
    startTime: string,
    endTime: string,
    subCategory?: string,
    clientTreeType?: IClientTreeType,
    cancelDate?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleRangeStartTimeEndTimeGet(
        startTime,
        endTime,
        subCategory,
        clientTreeType,
        cancelDate,
        maxItemCount,
        continuationToken,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_edit
   * @summary Update actualEndTime of an existing schedule
   * @param {string} scheduleId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IActualEndTimeDto} [iActualEndTimeDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleScheduleScheduleIdActualEndTimePut(
    scheduleId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iActualEndTimeDto?: IActualEndTimeDto,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleScheduleScheduleIdActualEndTimePut(
        scheduleId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iActualEndTimeDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: schedule_edit                Radianse.App.Connectors calls this endpoint via schedule client
   * @summary Update ActualStartTime of an existing schedule
   * @param {string} scheduleId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IActualStartTimeDto} [iActualStartTimeDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScheduleApi
   */
  public userApiScheduleScheduleScheduleIdActualStartTimePut(
    scheduleId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iActualStartTimeDto?: IActualStartTimeDto,
    options?: RawAxiosRequestConfig
  ) {
    return ScheduleApiFp(this.configuration)
      .userApiScheduleScheduleScheduleIdActualStartTimePut(
        scheduleId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        iActualStartTimeDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
